<template>
  <v-dialog :value="userIsNew.value" :max-width="580" :persistent="true">
    <div class="content">
      <h5 class="title mb-5">
        Пользовательское соглашение и Политика конфиденциальности
      </h5>

      <PDFViewer
        class="mb-4"
        url="29.01.2021 Пользовательское соглашение ЛК + политика.pdf"
      />

      <!-- Для IE11 скачивание не работает, поэтому target="_blank"    -->
      <div>
        <a href="Пользовательское соглашение.docx" download target="_blank">
          Скачать файл пользовательского соглашения
        </a>
      </div>
      <div>
        <a href="Политика конфиденциальности.docx" download target="_blank">
          Скачать файл политики конфиденциальности
        </a>
      </div>

      <v-checkbox
        v-model="agree"
        label="Ознакомлен и согласен с пользовательским соглашением и политикой конфиденциальности"
        hide-details
      />

      <v-row class="text-right">
        <v-col cols="auto">
          <v-btn
            depressed
            color="primary"
            class="button-base"
            @click="AuthModule.logout()"
            >Отмена</v-btn
          >
        </v-col>
        <v-col cols="auto">
          <v-btn
            depressed
            color="primary"
            class="button-base"
            :disabled="!agree"
            @click="
              StatementsModule.setUserIsNew({ value: false, loaded: true })
            "
            >Далее</v-btn
          >
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import { StatementsModule } from '@/store/modules/statements';
import { AuthModule } from '@/store/modules/auth';
import PDFViewer from '@/components/base/PDFViewer';

export default {
  name: 'Agreement',
  components: { PDFViewer },
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StatementsModule,
    AuthModule,
    agree: false,
  }),
  computed: {
    userIsNew() {
      return StatementsModule.userIsNew;
    },
  },
  created() {
    if (this.isAuthenticated && !this.userIsNew.loaded) {
      StatementsModule.getUserIsNew();
    }
  },
};
</script>

<style scoped lang="scss">
.title {
  font-family: 'Helvetica', sans-serif !important;
  color: $color-base;
}

.content {
  padding: 24px;
  background-color: white;
}
</style>
